module.exports = __webpack_public_path__ + "assets/img/init_pos_wallpaper2.32b2e053.png";